<nz-card nzBorderless class="customer-management-card">
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
    <h1 class="text-xl font-medium m-0 text-primary">CUSTOMERS</h1>
  </div>

  <div class="flex flex-col md:flex-row justify-between items-start md:items-center flex-wrap gap-4 mb-6">
    <nz-radio-group [(ngModel)]="quickFilter" (ngModelChange)="filterData()" nzButtonStyle="outline">
      <label nz-radio-button nzValue="all" class="font-semibold radio-button-primary">
        <i nz-icon nzType="unordered-list" nzTheme="outline" class="mr-2"></i>
        All {{counts.total_count}}
      </label>
      <label nz-radio-button nzValue="active" class="font-semibold radio-button-success">
        <i nz-icon nzType="hezky:Gateway" nzTheme="outline" class="mr-2"></i>
        Active {{counts.active_count}}
      </label>
      <label nz-radio-button nzValue="inactive" class="font-semibold radio-button-warning">
        <span class="text-[9px] text-[#B7B7B7]">x</span>
        <i class="mr-2" style="font-size: 14px !important;color: rgb(176, 180, 180);" nz-icon
          [nzType]="'hezky:Signal'"></i>
        Inactive {{counts.inactive_count}}
      </label>
    </nz-radio-group>

    <div class="flex items-center gap-3">
      <button nz-button nzType="default" type="button" aria-label="Search" nzShape="circle"
        (click)="searchEnabled = !searchEnabled" *ngIf="!searchEnabled" class="shadow-sm">
        <i nz-icon nzType="search"></i>
      </button>
      <nz-input-group [nzPrefix]="searchIcon" *ngIf="searchEnabled" class="w-60 shadow-sm">
        <input nz-input type="search" [(ngModel)]="searchText" placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)">
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button nz-button nzType="default" type="button" aria-label="Refresh" nzShape="circle" (click)="refreshHandler()"
        class="shadow-sm">
        <i nz-icon nzType="reload"></i>
      </button>
      <button nz-button nzType="primary" type="button" (click)="addEditCustomer('add')" class="shadow-sm">
        <i nz-icon nzType="plus" class="mr-1"></i>Add Customer
      </button>
    </div>
  </div>

  <div class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm">
    <nz-table #nzTable nzShowSizeChanger [nzLoading]="this.apiCallLoaders['isCustomerLoading']"
      [nzScroll]="{ x: '1024px', y: '55dvh' }" [nzSize]="'middle'" [nzPaginationType]="'small'"
      [nzShowTotal]="totalTemplate" [nzTotal]="this.counts['total_count']" [nzData]="filteredCustomerList$">
      <thead>
        <tr>
          <th nzWidth="130px">Status</th>
          <th nzWidth="200px" nzEllipsis="...">Company Name</th>
          <th nzWidth="200px" nzEllipsis="...">Contact Person</th>
          <th nzWidth="300px" nzEllipsis="...">Customer Email</th>
          <th nzWidth="150px">Contact</th>
          <th style="text-align: center;" nzWidth="80px">Edit</th>
          <th style="text-align: center;" nzWidth="100px">Login</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of nzTable.data; let i = index;trackBy: commonSvc.trackByFn"
          [ngClass]="{'bg-red-200 hover:bg-red-50': data?.is_active === false}">
          <td>
            <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium" [ngClass]="{
                'bg-green-50 text-green-600 hover:bg-green-100': data?.is_active,
                'bg-red-50 text-red-600 hover:text-red-600': !data?.is_active
              }">
              <i *ngIf="data?.is_active" nz-icon nzType="check-circle" class="mr-1"></i>
              <i *ngIf="!data?.is_active" nz-icon nzType="close-circle" class="mr-1"></i>
              {{ data?.is_active ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
            <a [routerLink]="['/customer/'+data?.customer_id]" class="font-medium hover:text-primary">
              {{ data?.company_name }}
            </a>
          </td>
          <td>{{ data?.contact_person }}</td>
          <td>{{ data?.contact_email }}</td>
          <td>{{ data?.contact_number}}</td>
          <td style="text-align: center;">
            <button nz-button nzType="default" nzShape="circle" aria-label="Edit customer"
              class="text-primary border-0 shadow-none" (click)="addEditCustomer('edit', data)">
              <i nz-icon nzType="edit"></i>
            </button>
          </td>
          <td style="text-align: center;">
            <button nz-button nzType="primary" nzSize="small" aria-label="Login as customer" class="shadow-sm">
              <i nz-icon nzType="login" class="mr-1"></i>Login
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-card>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="isEditMode ? 'Edit Customer' : 'Add New Customer'"
  (nzOnCancel)="isVisible = false" [nzWidth]="500" [nzClosable]="!isConfirmLoading"
  [nzMaskClosable]="!isConfirmLoading">

  <ng-template #sensorContent>
    <form nz-form [formGroup]="form" role="form" aria-labelledby="form" class="grid grid-cols-1 gap-y-4">
      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="customer_name">Company Name</nz-form-label>
        <nz-form-control [nzErrorTip]="'Company Name is required'">
          <input nz-input formControlName="company_name" class="w-full" maxlength="50"
            placeholder="Enter Company Name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="contact_person">Contact Person</nz-form-label>
        <nz-form-control [nzErrorTip]="'Contact Person is required'">
          <input nz-input formControlName="contact_person" class="w-full" maxlength="50"
            placeholder="Enter Contact Person" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="email">Email</nz-form-label>
        <nz-form-control [nzErrorTip]="'Email is required'">
          <input nz-input type="email" formControlName="contact_email" class="w-full" placeholder="Enter Email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="contact_number">Contact Number</nz-form-label>
        <nz-form-control [nzErrorTip]="'Contact number is required'">
          <input nz-input type="text" formControlName="contact_number" class="w-full" maxlength="10"
            placeholder="Enter Contact number" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzFor="compliance_level">Compliance Level</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="compliance_level" nzMode="multiple" nzPlaceHolder="Select compliance levels"
            class="w-full">
            <nz-option *ngFor="let option of complianceLevelOptions" [nzValue]="option.value" [nzLabel]="option.label"
              [nzDisabled]="isComplianceOptionDisabled(option.value)"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="application_id">Application</nz-form-label>
        <nz-form-control [nzErrorTip]="'Application is required'">
          <nz-select formControlName="application_id" nzMode="multiple" nzPlaceHolder="Select applications"
            class="w-full" nzShowSearch>
            <nz-option *ngFor="let app of applications" [nzValue]="app.id" [nzLabel]="app.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

    </form>
  </ng-template>

  <ng-template #sensorFooter>
    <div class="flex justify-end gap-3">
      <button nz-button nzType="default" (click)="isVisible = false" [disabled]="isConfirmLoading">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isConfirmLoading"
        [disabled]="isConfirmLoading">
        {{ isEditMode ? 'Update' : 'Submit' }}
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="sensorContent"></ng-container>
  </ng-container>

  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="sensorFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>
  <span class="text-gray-600">Showing {{ total }} items</span>
</ng-template>